import _ from 'lodash'
class viewCartController {
    /* @ngInject */
    constructor(siteLinksService, accountService, environment) {
        this.siteLinksService = siteLinksService;
        this.accountService = accountService;
        this.environment = environment;
    }

    $onInit() {
        this.USER_TYPE = this.environment.USER_TYPE;
        this.cart = this.viewCartModel ? this.viewCartModel : [];
        this.continueShoppingLink = this.siteLinksService.continueShoppingLink;
        this.checkoutLink = this.siteLinksService.checkoutLink;
        this.isLoggedInUser = this.accountService.isLoggedInUser();
        this.errorTypes = {
            CART_ERROR: 'cart-error',
            EMPTY_CART: 'no-product',
            LOGIN_REQUIRED: 'login-required',
            EXPIRED_QUOTES: 'expired-quotes',
            INVALID_PRODUCTS: 'invalid-products'
        };
        this.cartErrors = this.getCartErrors();
    }

    hasInvalidProducts() {
        var invalidProduct = _.find(this.cart.products, {
            'isValid': false
        });

        return !!invalidProduct;
    };

    hasExpiredQuotes() {
        var expiredQuote = _.find(this.cart.products, {
            'isQuoteExpired': true
        });

        return expiredQuote;
    };

    hasQuotes() {
        var quotes = _.find(this.cart.products, 'quoteId');

        return quotes;
    }

    canViewQuotePrices() {

        return this.isLoggedInUser;
    }

    displayLoginMessage() {

        if(!this.canViewQuotePrices() && this.hasQuotes()) {

            return true;
        }

        return false;
    }

    getCartErrors() {

        if(!this.cart.products || this.cart.products.length === 0) {
            return this.errorTypes.EMPTY_CART;
        }
        else if(this.displayLoginMessage()) {
            return this.errorTypes.LOGIN_REQUIRED;
        }
        else if(this.hasInvalidProducts()) {
            return this.errorTypes.INVALID_PRODUCTS;
        }
        else if(this.hasExpiredQuotes()) {
            return this.errorTypes.EXPIRED_QUOTES;
        }

        return null;
    }
}

export default viewCartController;



// WEBPACK FOOTER //
// ./src/app/components/view-cart/view-cart.controller.js